import { useQuery } from 'react-query'

import { url, getCustomHeaders } from 'components/DataProvider/functions'
import { isNil } from 'lodash/fp'
import axios, { type AxiosHeaders } from 'axios'
import { assign } from 'lodash'

export const useGetSummaryItems = (
  partner: string | undefined
): { isLoading: boolean; data: string[] } => {
  const { data, isLoading } = useQuery({
    queryKey: ['summary', partner],
    queryFn: async () => {
      if (isNil(partner)) return undefined
      if (isNil(url)) return undefined
      const customHeaders = getCustomHeaders({}, partner) as
        | AxiosHeaders
        | undefined
      if (isNil(customHeaders)) return undefined
      const headers = {
        Authorization: customHeaders.get('Authorization')
      }
      if (!isNil(partner)) {
        assign(headers, { 'X-Partner': partner })
      }
      const { status, data } = await axios.get(`${url}/summary`, {
        headers
      })
      if (status !== 200) return undefined
      return data
    }
  })
  return { isLoading, data: !isNil(data) ? data.items : data }
}
